const OfferingsTitle = ({ children, error }) => {
  return <h4 className={`u-margin-top u-margin-bottom-lg ${!!error ? 'u-text-danger' : ''}`}>{children}</h4>;
};

export default OfferingsTitle;
